/* unplugin-vue-components disabled */import script from "./TargetTree.vue?vue&type=script&setup=true&name=TargetTree&lang=js"
export * from "./TargetTree.vue?vue&type=script&setup=true&name=TargetTree&lang=js"

import "./TargetTree.vue?vue&type=style&index=0&id=0741dfdc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0741dfdc"]])

export default __exports__